import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"
import CustomerForm from "./Form"

import * as ItemTypes from "../../redux/items/types"
import { getCustomerLoans, resetCustomerLoans } from "../../redux/actions/loans"
import FontAwesome from "react-fontawesome"

class DetailCustomer extends Component {

  componentDidMount() {

    const { loadBusinesses, params,
      doResetCustomerLoans, reloadCustomer } = this.props

    reloadCustomer(params.id)
    doResetCustomerLoans()
    loadBusinesses()
  }

  render() {

    const { customer, customerLoans, businesses, setCustomer, getCustomerLoans } = this.props
    if(!customer) return <p><FontAwesome name='clock-o'/> Running ..</p>

    return <CustomerForm 
      customer={ customer }
      customerLoans={ customerLoans }
      getCustomerLoans={ getCustomerLoans }
      setCustomer={ setCustomer }
      businesses={ businesses }
    />
  }
}

DetailCustomer.propTypes = {
  customer: PropTypes.object,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, { params: { id: customerId }}) => {

  const pagedCustomers = DckSelectors.selectAllItems(state, ItemTypes.Customer),

  customer = pagedCustomers.content
    ? pagedCustomers.content.find(item => item.id === customerId)
    : undefined,

  customerLoans = DckSelectors.selectAllItems(
    state,
    ItemTypes.CustomerLoans
  ),

  businesses = DckSelectors.selectAllItems(state, ItemTypes.Business)
  businesses.reverse()

  return { customer, customerLoans, businesses }
},

mapDispatchToProps = dispatch => ({

  reloadCustomer: id => dispatch(DckActionCreators.itemReload(ItemTypes.Customer, id)),

  setCustomer: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Customer, id, data)),

  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),

  getCustomerLoans: customerId => dispatch(getCustomerLoans(customerId)),

  doResetCustomerLoans: () => dispatch(resetCustomerLoans()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailCustomer)



// WEBPACK FOOTER //
// ./src/components/Customers/Detail.js